import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'pagination-infinite-scroll',
  templateUrl: './pagination-infinite-scroll.component.html',
})
export class PaginationInfiniteScrollComponent implements AfterViewInit, OnDestroy {
  @Input() public options: any = {};
  @Output() public scrolled: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('anchor') public anchor: ElementRef<HTMLElement>;

  private observer: IntersectionObserver;

  constructor(private host: ElementRef) {}

  public ngAfterViewInit(): void {
    const options: any = {
      root: this.isHostScrollable() ? this.host.nativeElement : null,
      threshold: [0.3],
      ...this.options,
    };

    this.observer = new IntersectionObserver(([entry]: [IntersectionObserverEntry]) => {
      if (entry.isIntersecting) {
        this.scrolled.emit();
      }
    }, options);

    this.observer.observe(this.anchor.nativeElement);
  }

  public ngOnDestroy(): void {
    this.observer.disconnect();
  }

  private isHostScrollable(): boolean {
    const style: any = window.getComputedStyle(this.element);

    return style.getPropertyValue('overflow') === 'auto' || style.getPropertyValue('overflow-y') === 'scroll';
  }

  private get element(): HTMLElement {
    return this.host.nativeElement;
  }
}
